const comments = [
  {
    name: '漫画迷小王',
    avatar: '王',
    time: '2天前',
    text: 'YY漫画网真的很方便！下拉式阅读太流畅了，再也不用点来点去翻页了。韩漫资源特别全，我最喜欢的几部都在这里找到了，而且更新速度超快，强烈推荐！',
    likes: 128,
    tag: '韩漫爱好者',
  },
  {
    name: '日漫老司机',
    avatar: '李',
    time: '3天前',
    text: '作为一个看了十几年日漫的老粉，这个网站的漫画排行榜做得很专业，分类也很清晰。现在每天都要上来看看有没有新的好看的漫画更新，已经成了我每天的必修课。',
    likes: 96,
    tag: '日漫铁粉',
  },
  {
    name: '追更不停歇',
    avatar: '陈',
    time: '5天前',
    text: '国漫最近几年质量提升太多了！在YY漫画网追了好几部国漫，画面精美剧情在线。免费漫画那么多，全集都能下拉式看完，简直是漫画爱好者的天堂。',
    likes: 85,
    tag: '国漫支持者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            读者心声
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            听听漫画爱好者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((c) => (
            <div
              key={c.name}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-heading font-bold text-base">{c.avatar}</span>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{c.name}</h3>
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
                      {c.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-400 mt-0.5">{c.time}</p>
                </div>
              </div>

              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>

              <div className="flex items-center gap-4 mt-4 pt-4 border-t border-background-200/70">
                <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-thumb-up-line"></i>
                  </span>
                  {c.likes}
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-chat-1-line"></i>
                  </span>
                  回复
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}